import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const posSalesTrendWidget: DashboardWidgetConfiguration = {
  widgetId: "pos.sales-trend",
  name: "POS sales trend",
  description: "POS sales trend across the selected period.",
  apps: [
    "point-of-sale",
  ],
  template: "graph",
  query: {
    kind: "graph",
    valueQuery: {
      version: 1,
      source: "pos.orders",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "sum",
          field: "total_amount",
          as: "value",
        },
      ],
    },
    graphQueries: [
      {
        name: "Sales",
        query: {
          version: 1,
          source: "pos.orders",
          ...period(30),
          select: [
            {
              type: "field",
              field: "order_time",
              bucket: "day",
              as: "day",
            },
            {
              type: "aggregate",
              function: "sum",
              field: "total_amount",
              as: "value",
            },
          ],
          group_by: [
            {
              field: "order_time",
              bucket: "day",
            },
          ],
          order_by: [
            {
              ref: "day",
              direction: "asc",
            },
          ],
        },
        type: "area",
        color: "#2fb344",
        lineWidth: 2,
        fillOpacity: 0.16,
        valueMultiplier: 1,
      },
    ],
  },
  inputs: {
    title: "POS sales trend",
    valueFormat: "currency",
    valueMultiplier: 1,
    graphPadding: true,
    chartHeight: 112,
    curve: "smooth",
  },
  dummyData: {
    value: "$32,840",
    series: [
      18,
      24,
      20,
      32,
      29,
      41,
      48,
    ],
  },
  limits: {
    minWidth: 3,
    maxWidth: 12,
    minHeight: 2,
    maxHeight: 6,
    defaultWidth: 6,
    defaultHeight: 3,
  },
};
